// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"208":"vespa-settings","472":"settings","659":"glossaries","945":"dashboard"}[chunkId] || chunkId) + "." + {"208":"9cdc71be","304":"111e0611","305":"11f5286e","472":"1afe5e21","659":"fef23301","774":"2b1ae0c1","807":"2703ca58","945":"7380818b"}[chunkId] + ".chunk.js";
};